import { useState, useEffect } from 'react';
import { db } from '../../utils/firebase.util';
import {
  collection,
  getDocs,
  updateDoc,
  doc,
  deleteDoc,
} from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';

import './admin.styles.scss';
import MyModal from '../../components/modal/modal.component';

const Admin = () => {
  const [clients, setClients] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const clientsCollectionRef = collection(db, 'clients');
  const navigate = useNavigate();

  // TODO: do it real!!!
  const updateClient = async (id, firstName) => {
    const clientDoc = doc(db, 'clients', id);
    const newFields = {
      firstName: 'Nikita',
    };
    await updateDoc(clientDoc, newFields);
  };

  const deleteClient = async (id) => {
    const clientDoc = doc(db, 'clients', id);
    await deleteDoc(clientDoc);
    alert('client succesfully deleted!');
  };

  useEffect(() => {
    const getClients = async () => {
      const data = await getDocs(clientsCollectionRef);
      setClients(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
    };

    getClients();
  }, []);

  return (
    <div className='admin-page'>
      <h1>Адмін Панель</h1>

      <MyModal show={showModal} setShow={setShowModal} />

      <button className='btn btn-success' onClick={() => setShowModal(true)}>
        Додати Клієнта вручну
      </button>

      <table className='table container text-center'>
        <thead>
          <tr>
            <th scope='col'>Ім'я</th>
            <th scope='col'>Прізвище</th>
            <th scope='col'>Email</th>
            <th scope='col'>Телефон</th>
            <th scope='col'>Повідомлення</th>
          </tr>
        </thead>
        <tbody>
          {clients.length > 0 ? (
            clients.map((client) => {
              return (
                <tr key={client.id}>
                  <td>{client.firstName}</td>
                  <td>{client.lastName}</td>
                  <td>{client.email}</td>
                  <td>{client.phone}</td>
                  <td>{client.message}</td>
                  <td>
                    <button
                      className='btn btn-warning'
                      onClick={() => updateClient(client.id, client.firstName)}
                    >
                      Edit
                    </button>
                  </td>
                  <td>
                    <button
                      className='btn btn-danger'
                      onClick={() => deleteClient(client.id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td scope='row'>
                <h1>
                  Наразі немає жодного клієнта. Вкладіться в рекламу, чи шо...
                </h1>
              </td>
            </tr>
          )}
        </tbody>
      </table>
      <button className='btn-primary btn' onClick={() => navigate('/')}>
        На сайт
      </button>
    </div>
  );
};

export default Admin;
